import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const MicronesiaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14706'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14706)'>
				<rect
					width='20'
					height='14'
					fill='#95CEF5'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.88038 4.77686L9.99997 4.03202L11.1196 4.77686L10.7427 3.50319L11.8115 2.68986L10.459 2.64752L9.99997 1.40002L9.54093 2.64752L8.18843 2.68986L9.25724 3.50319L8.88038 4.77686ZM8.88038 12.2435L9.99997 11.4987L11.1196 12.2435L10.7427 10.9699L11.8115 10.1565L10.459 10.1142L9.99997 8.86669L9.54093 10.1142L8.18843 10.1565L9.25724 10.9699L8.88038 12.2435ZM13.8095 7.76536L12.6899 8.51019L13.0668 7.23653L11.998 6.42319L13.3505 6.38086L13.8095 5.13336L14.2685 6.38086L15.621 6.42319L14.5522 7.23653L14.9291 8.51019L13.8095 7.76536ZM5.07085 8.51019L6.19044 7.76536L7.31003 8.51019L6.93317 7.23653L8.00198 6.42319L6.64947 6.38086L6.19044 5.13336L5.73141 6.38086L4.37891 6.42319L5.44771 7.23653L5.07085 8.51019Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default MicronesiaFlagIcon;
